<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">취약점 제보</h1>
      <h2 class="page-tit">취약점 신고 관리</h2>
    </div>
    <!-- 목록 -->
    <!-- 취약점 신고 내역 -->
    <section class="section-pt report-history">
      <!-- 취약점 신고 내역 head -->
      <h3 class="section-title">취약점 신고 내역</h3>
      <div class="list-table__top">
        <p class="list-table__total">총 {{ total }}건</p>
        <div class="list-table__search">
          <label for="search-type" class="sr-only">검색 조건</label>
          <select name="" id="search-type" v-model="searchInfo.searchOption">
            <option value="vulTitle">제목</option>
            <option value="vulSummary">내용</option>
          </select>
          <label for="searchKeyword" class="sr-only"
            >검색어를 입력해주세요</label
          >
          <input
            type="text"
            v-model="searchInfo.content"
            placeholder="검색어를 입력해주세요"
            @keyup.enter="getRecordList(1)"
          />
          <button
            type="button"
            class="btn btn--blue btn--m"
            @click="getRecordList(1)"
          >
            <i class="svg_icon icon_search white"></i>검색
          </button>
          <button
            type="button"
            class="btn btn--green btn--m"
            @click="openModal"
          >
            취약점 인증서
          </button>
        </div>
      </div>
      <!-- 취약점 신고 내역 테이블 -->
      <table class="list-table type-block--mobile">
        <caption>
          취약점 신고접수결과 검색 목록
        </caption>
        <colgroup>
          <col width="8%" />
          <col width="12%" />
          <col width="30%" />
          <col width="15%" />
          <col width="10%" />
          <col width="10%" />
          <col width="15%" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">순번</th>
            <th scope="col">상태</th>
            <th scope="col">제목</th>
            <th scope="col">KVE/CVE</th>
            <th scope="col">위험도</th>
            <th scope="col">포상금(만원)</th>
            <th scope="col">제보일</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in items"
            :key="item.id"
            @click="goToDetail(item)"
            class="clickable-row"
          >
            <td class="no-field">
              {{ convertId(index) }}
            </td>
            <td class="info-field" :ref="(el) => (statusTdRefs[index] = el)">
              <div class="status-popover">
                <span
                  @mouseover="getReportStatus(item, index)"
                  @mouseleave="hideTimelineTooltip"
                  style="color: #005fa3"
                  :aria-controls="index"
                  :aria-describedby="index"
                >
                  {{ item.status || "-" }}
                  <div
                    :id="index"
                    v-if="showTimelineTooltip && tooltipTargetIndex === index"
                    class="status-popover__popover"
                    role="tooltip"
                    aria-live="polite"
                  >
                    <div class="status-popover__popover-inner">
                      <ReportTimeline
                        :timelineTooltipData="timelineTooltipData"
                      />
                    </div>
                    <span
                      class="status-popover__arrow"
                      aria-hidden="true"
                    ></span>
                  </div>
                </span>
              </div>
            </td>
            <td class="tit-field">
              <span class="ellipsis" :title="item.vulTitle || '-'">{{
                item.vulTitle || "-"
              }}</span>
            </td>
            <td class="info-field">
              <span class="th--only-mobile">KVE/CVE</span>{{ item.kve || "-" }}
            </td>
            <td class="info-field">
              <span class="th--only-mobile">위험도</span
              >{{ item.severity || "-" }}
            </td>
            <td class="info-field">
              <span class="th--only-mobile">포상금(만원)</span
              >{{ item.finalReward || "-" }}
            </td>
            <td class="info-field">
              <span class="th--only-mobile">제보일</span
              >{{ convertDateFormat(item.regDate) }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="items == null || items.length == 0" class="no-data">
        {{
          isLoading
            ? "데이터 조회중입니다. 잠시만 기다려주십시오."
            : "검색 결과 없음..."
        }}
      </div>
      <Paging
        v-model="pagingInfo.currentPage"
        :totalItems="total"
        :visibleCount="pagingInfo.limitNum"
        @update:modelValue="getPage"
      />
    </section>
    <!-- ReportCertDown 컴포넌트가 자체적으로 모달 관리 -->
    <ReportCertDown :isModal="isModal" @close="closeModal" />
  </div>
</template>

<script>
import dc from "@/component/utils/DataChk.js";
import dt from "@/component/utils/DateTime.js";
import Modal from "@/component/modal/Modal.vue";
import pageNav from "@/component/paging/PageNav.vue";
import pageSelect from "@/component/paging/PageSelect.vue";
import paging from "@/component/paging/Paging.js";
import Paging from "@/component/paging/Paging.vue";
import tb from "@/component/utils/Table.js";
import ReportCertDown from "@/views/report/modal/ReportCertDown.vue";
import ReportTimeline from "@/views/report/records/ReportTimeline.vue";
import { computed, inject, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    pageSelect,
    pageNav,
    Paging,
    ReportTimeline,
    Modal,
    ReportCertDown,
  },
  setup() {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");
    // data 정의
    const pagingInfo = reactive({
      currentPage: 1, // 현재페이지
      prePage: 1, // 이전페이지
      perPage: 10, // n개씩보기
      limitNum: 5, // 화면에 표시할 페이지 수
      type: 1, // 1 = 처음부터 조회, 2 = preKey/nextKey 사용, 3 = n개씩보기 변경
      total: -1,
      pageNum: 0,
      doubleTab: false,
    });
    const searchInfo = ref({
      sortBy: "_id",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      searchOption: "vulTitle",
      content: "",
      tabs: "",
    });
    const savedSearchInfo = ref({
      // getRecordList(1) 후 저장된 검색 조건
      sortBy: "regDate",
      order: -1,
      skipCount: 0,
      limit: 0,
      preKey: "",
      nextKey: "",
      changePerpage: false,
      searchOption: "vulTitle",
      content: "",
      tabs: "",
    });
    const total = ref(-1);
    const items = ref([]);
    const router = useRouter();
    const showTimelineTooltip = ref(false);
    const timelineTooltipData = ref(null);
    const tooltipTargetIndex = ref(null);
    const statusTdRefs = ref([]);
    const isModal = ref(false);
    const activeIndex = ref(null);

    // methods 정의
    const getRecordList = async (type) => {
      searchInfo.value = dc.trimObject(searchInfo.value);
      const axiosSearchInfo = tb.getSearchInfo(
        type,
        searchInfo,
        savedSearchInfo
      );

      pagingInfo.type = type;
      if (type !== 2) {
        total.value = -1;
        paging
          .total("/report/pr/records/count/get", axiosSearchInfo)
          .then((res) => {
            total.value = res;
          });
      }

      paging
        .getPageItems("/report/pr/records/get", axiosSearchInfo, pagingInfo)
        .then((res) => {
          items.value = res;
          pagingInfo.doubleTab = true;
        });

      // 검색 조건 저장
      tb.saveSearchInfo(type, searchInfo, savedSearchInfo);
    };
    // 진행 상태 조회
    const getReportStatus = (item, index) => {
      const data = {
        vulId: item.vulId,
      };
      axios
        .post("/report/pr/records/status/get", data)
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            timelineTooltipData.value = res.data.resList;
            tooltipTargetIndex.value = index;
            showTimelineTooltip.value = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    const convertId = (index) => {
      // total.value 쉼표를 제거하고 숫자로 변환
      const totalCount = parseInt(String(total.value).replace(/,/g, ""), 10);
      if (isNaN(totalCount) || totalCount <= 0) {
        return 0;
      }
      const offset = (pagingInfo.currentPage - 1) * pagingInfo.perPage;

      if (pagingInfo.currentPage > 1) {
        return totalCount - offset - index;
      }
      return totalCount - index;
    };
    const goToDetail = (item) => {
      // 검색 조건을 sessionStorage에 저장
      tb.saveStateForDetail("reportRecord", searchInfo.value, pagingInfo);
      router.push({
        name: "reportRecordDetail",
        query: {
          id: item.vulId,
        },
      });
    };
    const getPage = (page, pageNum) => {
      // 페이징 클릭 시 목록 조회
      pagingInfo.currentPage = page;
      pagingInfo.pageNum = page - pagingInfo.currentPage; // 클릭한 페이지 기준 차이
      pagingInfo.doubleTab = false;
      getRecordList(2);
    };
    const convertDateFormat = (date) => {
      return dt.dateTimeFormat(date);
    };
    const hideTimelineTooltip = () => {
      showTimelineTooltip.value = false;
      tooltipTargetIndex.value = null;
      timelineTooltipData.value = null;
    };
    const openModal = () => {
      isModal.value = true;
    };
    const closeModal = () => {
      isModal.value = false;
    };

    const toggle = (i) => {
      activeIndex.value = activeIndex.value === i ? null : i;
    };

    // computed 정의
    const isLoading = computed(() => store.state.loading.isLoading);

    // life cycle 정의
    onMounted(() => {
      const retrievedState = tb.retrieveAndClearState(
        "reportRecord",
        "reportRecordDetail",
        searchInfo,
        savedSearchInfo,
        pagingInfo
      );
      const {
        type: type,
        searchInfo: parsedSearchInfo,
        pagingInfo: parsedPagingInfo,
      } = retrievedState;
      getRecordList(type);
    });
    // html에서 사용될 데이터 정의
    return {
      pagingInfo,
      searchInfo,
      savedSearchInfo,
      getRecordList,
      items,
      total,
      getPage,
      convertDateFormat,
      goToDetail,
      convertId,
      getReportStatus,
      showTimelineTooltip,
      timelineTooltipData,
      tooltipTargetIndex,
      hideTimelineTooltip,
      statusTdRefs,
      openModal,
      isModal,
      closeModal,
      activeIndex,
      toggle,
      isLoading,
    };
  },
};
</script>
